// Reguli globale pentru selectoarele de an: niciun an sub 2026.
export const MIN_YEAR = 2026;

export const MONTHS_RO = [
  "Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie",
  "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie",
];

/** Listă de ani pentru dropdown: de la 2026 până la cel puțin 2028 (extinde dacă e nevoie). */
export function yearOptions(current) {
  const nowY = new Date().getFullYear();
  const max = Math.max(2028, nowY + 1, current || 0);
  const arr = [];
  for (let y = MIN_YEAR; y <= max; y++) arr.push(y);
  return arr;
}
